// extracted by mini-css-extract-plugin
export default {"text":"approvePurchase_text__eoeub"};